import { Maybe } from 'generated/sanity-graphql';

export const getUniqueComponents = (components?: Maybe<ReadonlyArray<any>> | null) =>
  (components ?? []).reduce((acc: any, comp: any) => {
    acc[comp.__typename] = comp._id;

    return acc;
  }, {});
